var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"duo-callback"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"50","width":"5"}}),_c('div',{staticClass:"status-text"},[_vm._v("Completing Duo login...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }